import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { ApiEndPointUrl, apiVersionPath } from 'src/app/utils/systemEnums';
import { ProgressBarService } from '../components/progress-bar/progress-bar.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BehaviorSubject, from, Observable, switchMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceLocal {
  public get userValue(): any {
    return JSON.parse(localStorage.getItem('authUser'));
  }
  standardOrderListingPagination = {
    pageIndex: 1,
    pageSize: 10,
    isDataLoading: 0,
    isDataNotFound: 0,
    totalRecords: 0,
  };
  bulkOrderListingPagination = {
    pageIndex: 1,
    pageSize: 10,
    isDataLoading: 0,
    isDataNotFound: 0,
    totalRecords: 0,
  };
  heavyOrderListingPagination = {
    pageIndex: 1,
    pageSize: 10,
    isDataLoading: 0,
    isDataNotFound: 0,
    totalRecords: 0,
  };
  interRegionalOrderListingPagination = {
    pageIndex: 1,
    pageSize: 10,
    isDataLoading: 0,
    isDataNotFound: 0,
    totalRecords: 0,
  };

  _configuration = {
    API_ENDPOINT: ApiEndPointUrl,
  };
  public walletAmount: BehaviorSubject<number>;
  public userProfileData: any;
  public api_version: string;

  // const url = isProd ? 'https://api4.phlenu.com:8080/api/resetpassword' : 'https://apistage.phlenu.com/api/resetpassword';

  orderInfo: string;

  constructor(
    private _progressBar: ProgressBarService,
    private _dataService: DataService,
    private _router: Router,
    private _matSnackBar: MatSnackBar,
    private _location: Location,
    private afAuth: AngularFireAuth,
    private _bottomSheet: MatBottomSheet,
  ) {
    this.walletAmount = new BehaviorSubject(0);
    this.userProfileData = new BehaviorSubject(null);
  }

  public goBack() {
    this._location.back();
  }

  public userLogout() {
    // Close any open bottom sheets before logout
    try {
      this._bottomSheet.dismiss();
    } catch (error) {
      // Ignore errors if no bottom sheet is open
    }

    localStorage.removeItem('PWAToken');
    localStorage.removeItem('country');
    localStorage.removeItem('phoneCode');
    localStorage.removeItem('registerData');
    localStorage.removeItem('authUser');
    localStorage.removeItem('api_version');
    localStorage.removeItem('redirectByWA');
    localStorage.removeItem('PENDINGBULKORDERDATA');
    localStorage.removeItem('isBusinessPartner');
    localStorage.removeItem('PENDINGHEAVYORDERDATA');
    localStorage.removeItem('PENDINGORDERDATA');
    localStorage.removeItem('isWalletWelcomeShow');
    localStorage.clear();
    this._router.navigate(['/auth/login']);
  }

  // public getOrderHandlingType() {
  //     return this._dataService.getDataWithoutHeader(
  //         this._configuration.API_ENDPOINT + 'v12/customer/web/get-all-sendingItemsWithOutUser',
  //     );
  // }

  /* 
        API CALLED WITHOUT LOGIN 
    */
  public getApiVersion() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('api_version')) {
        this.api_version = localStorage.getItem('api_version');
      } else {
        if (this.api_version) {
          return resolve(this.api_version);
        } else {
          if (localStorage.getItem('PWAToken')) {
            return this._dataService
              .getDataWithHeader(apiVersionPath)
              .subscribe((res: any) => {
                this.api_version = res?.data?.api_version || '13';
                localStorage.setItem('api_version', this.api_version);
                resolve(this.api_version);
              });
          } else {
            return this._dataService
              .getDataWithoutHeader(apiVersionPath)
              .subscribe((res: any) => {
                this.api_version = res?.data?.api_version || '13';
                localStorage.setItem('api_version', this.api_version);
                resolve(this.api_version);
              });
          }
        }
      }
    });
  }

  public getCoverFeePercent(id): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callgetCoverFeePercentAPI(id)),
      );
    } else {
      return this.callgetCoverFeePercentAPI(id);
    }
  }

  callgetCoverFeePercentAPI(id): Observable<any> {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-cover-fee-percent/${id}`,
    );
  }

  public getOrderHandlingType(): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callgetOrderHandlingTypeAPI()),
      );
    } else {
      return this.callgetOrderHandlingTypeAPI();
    }
  }

  callgetOrderHandlingTypeAPI(): Observable<any> {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/customer/web/get-all-sendingItems',
    );
  }

  public getPromoCodeList(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callgetPromoCodeListAPI(body)),
      );
    } else {
      return this.callgetPromoCodeListAPI(body);
    }
  }

  public callgetPromoCodeListAPI(body): Observable<any> {
    return this._dataService.postDataWithHeader(
      // this._configuration.API_ENDPOINT + 'v' + this.api_version + '/pdas/web/applicablePromoCodeList', body
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-promo-code-list',
      body,
    );
  }

  public getBulkPromoCodeList(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callgetBulkPromoCodeListAPI(body)),
      );
    } else {
      return this.callgetBulkPromoCodeListAPI(body);
    }
  }

  public callgetBulkPromoCodeListAPI(body) {
    return this._dataService.postDataWithHeader(
      // this._configuration.API_ENDPOINT + 'v11/pdas/promoCodeList', body
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/applicableBulkPromoCodeList',
      body,
    );
  }

  /* 
        API FOR GET DELIVERY WINDOWS UPDATE.
    */
  public getDeliveryWindowUpdate(): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callgetDeliveryWindowUpdateAPI()),
      );
    } else {
      return this.callgetDeliveryWindowUpdateAPI();
    }
  }

  callgetDeliveryWindowUpdateAPI() {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT + 'v12/pdas/web/get-delivery-config',
    );
  }

  // standard order
  public confirmStandardOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callConfirmStandardOrderAPI(body)),
      );
    } else {
      return this.callConfirmStandardOrderAPI(body);
    }
  }

  public callConfirmStandardOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/place-order4',
      body,
    );
  }

  // THIS API FOR STANDARD ORDER WHEN ORDER PAYMENT TYPE IS ONLINE & WALLET. AFTER PAYMENT SUCCESSED OR FAILD THIS API CALLED.
  public standardOrderPaymentConfirm(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callStandardOrderPaymentConfirmAPI(body)),
      );
    } else {
      return this.callStandardOrderPaymentConfirmAPI(body);
    }
  }

  public callStandardOrderPaymentConfirmAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/update-order-payment2',
      body,
    );
  }

  // common file upload api
  public uploadFile(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callUploadFileAPI(body)),
      );
    } else {
      return this.callUploadFileAPI(body);
    }
  }

  public callUploadFileAPI(body) {
    const image = new FormData();
    image.append('PDASImage', body);
    return this._dataService.postDataWithHeaderFormData(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/upload-imags-for-PDAS',
      image,
    );
  }

  // bulk order
  public confirmBulkOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callConfirmBulkOrderAPI(body)),
      );
    } else {
      return this.callConfirmBulkOrderAPI(body);
    }
  }

  public callConfirmBulkOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/save-bulk-order-requestV2',
      body,
    );
  }

  // THIS API FOR BULK ORDER WHEN ORDER PAYMENT TYPE IS ONLINE & WALLET. AFTER PAYMENT SUCCESSED OR FAILD THIS API CALLED.
  public bulkOrderPaymentConfirm(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callBulkOrderPaymentConfirmAPI(body)),
      );
    } else {
      return this.callBulkOrderPaymentConfirmAPI(body);
    }
  }

  public callBulkOrderPaymentConfirmAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/update-bulk-order-payment',
      body,
    );
  }

  /* 
        info api.
    */
  public getOrderInfo(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetOrderInfoAPI(body)),
      );
    } else {
      return this.callGetOrderInfoAPI(body);
    }
  }

  public callGetOrderInfoAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/verbiageCollectCash',
      body,
    );
  }

  /* 
        Registration APIs
    */
  // check email id
  public onCheckEmail(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnCheckEmailAPI(body)),
      );
    } else {
      return this.callOnCheckEmailAPI(body);
    }
  }

  public callOnCheckEmailAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/emailChecker',
      body,
    );
  }

  /* check phone number */
  public onPhoneNumberCheck(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnPhoneNumberCheckAPI(body)),
      );
    } else {
      return this.callOnPhoneNumberCheckAPI(body);
    }
  }

  public callOnPhoneNumberCheckAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/numberChecker',
      body,
    );
  }

  /* v11/common/checkuser  check user exists */
  public checkUser(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callCheckUserAPI(body)),
      );
    } else {
      return this.callCheckUserAPI(body);
    }
  }

  public callCheckUserAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/checkuser',
      body,
    );
  }

  /* v12/pdas/webSignup main pdas regiter api */
  public onRegiter(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnRegiterAPI(body)),
      );
    } else {
      return this.callOnRegiterAPI(body);
    }
  }

  public callOnRegiterAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/signup',
      body,
    );
  }

  /* v12/pdas/webSignup main pdas regiter api */
  public downloadDeliveryAppFromAffiliateLink(body): Observable<any> {
    console.log('boddownloadDeliveryAppFromAffiliateLinky', body);
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callDownloadDeliveryAppFromAffiliateLink(body)),
      );
    } else {
      return this.callDownloadDeliveryAppFromAffiliateLink(body);
    }
  }

  public callDownloadDeliveryAppFromAffiliateLink(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/downloadDeliveryAppFromAffiliateLink',
      body,
    );
  }

  public getAffiliateCode(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callAffiliateCode(body)),
      );
    } else {
      return this.callAffiliateCode(body);
    }
  }

  public callAffiliateCode(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/get-affiliate-code',
      body,
    );
  }

  /* v12/pdas/login main pdas login api */
  public onLogin(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnLoginAPI(body)),
      );
    } else {
      return this.callOnLoginAPI(body);
    }
  }

  public callOnLoginAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/login',
      body,
    );
  }

  /* 
        ORDER LISTING APIS
    */

  public getStandardOrderList(payload): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetStandardOrderListAPI(payload)),
      );
    } else {
      return this.callGetStandardOrderListAPI(payload);
    }
  }

  public callGetStandardOrderListAPI(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-all-orders2`,
      payload,
    );
  }

  public getStandardOrderDetail(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetStandardOrderDetailAPI(body)),
      );
    } else {
      return this.callGetStandardOrderDetailAPI(body);
    }
  }

  public callGetStandardOrderDetailAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-order-detail2',
      body,
    );
  }

  public getBulkOrderList(data): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetBulkOrderListAPI(data)),
      );
    } else {
      return this.callGetBulkOrderListAPI(data);
    }
  }

  public callGetBulkOrderListAPI(data) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/getBulkOrderList2`,
      data,
    );
  }

  public getBulkOrderDetail(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetBulkOrderDetailAPI(body)),
      );
    } else {
      return this.callGetBulkOrderDetailAPI(body);
    }
  }

  public callGetBulkOrderDetailAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/bulkOrderDetails',
      body,
    );
  }

  public getHeavyOrderList(data): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetHeavyOrderListAPI(data)),
      );
    } else {
      return this.callGetHeavyOrderListAPI(data);
    }
  }

  public callGetHeavyOrderListAPI(data) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-heavy-relocation-order-history`,
      data,
    );
  }

  public getInterRegionalOrderList(data): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetInterRegionalOrderListAPI(data)),
      );
    } else {
      return this.callGetInterRegionalOrderListAPI(data);
    }
  }

  public callGetInterRegionalOrderListAPI(data) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-inter-regional-order-listing`,
      data,
    );
  }

  public onCancelInterRegionalOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnCancelInterRegionalOrderAPI(body)),
      );
    } else {
      return this.callOnCancelInterRegionalOrderAPI(body);
    }
  }

  public callOnCancelInterRegionalOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/cancel-inter-regional-order',
      body,
    );
  }

  // cancel standard order
  public onCancelStandardOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnCancelStandardOrderAPI(body)),
      );
    } else {
      return this.callOnCancelStandardOrderAPI(body);
    }
  }

  public callOnCancelStandardOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/cancel-order',
      body,
    );
  }

  public onCancelBulkOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnCancelBulkOrderAPI(body)),
      );
    } else {
      return this.callOnCancelBulkOrderAPI(body);
    }
  }

  public callOnCancelBulkOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/cancel-bulk-order',
      body,
    );
  }

  public onLoadTermsConditions(): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnLoadTermsConditionsAPI()),
      );
    } else {
      return this.callOnLoadTermsConditionsAPI();
    }
  }

  public callOnLoadTermsConditionsAPI() {
    return this._dataService.getDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/pages/web/terms',
    );
  }

  public onLoadPrivacypolicy(): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnLoadPrivacypolicyAPI()),
      );
    } else {
      return this.callOnLoadPrivacypolicyAPI();
    }
  }

  public callOnLoadPrivacypolicyAPI() {
    return this._dataService.getDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/pages/web/privacy',
    );
  }

  // OTP on regisation
  public verifyOTP(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callVerifyOTPAPI(body)),
      );
    } else {
      return this.callVerifyOTPAPI(body);
    }
  }

  public callVerifyOTPAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/verifyPhone',
      body,
    );
  }

  // make as pdas.
  // v12/pdas/make-user-for-package-delivery
  public onCreatePDAS(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnCreatePDASAPI(body)),
      );
    } else {
      return this.callOnCreatePDASAPI(body);
    }
  }

  public callOnCreatePDASAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/make-user-for-package-delivery',
      body,
    );
  }

  // v11/pdas/verifyUserByPhone
  public onVerifyUserByPhone(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnVerifyUserByPhoneAPI(body)),
      );
    } else {
      return this.callOnVerifyUserByPhoneAPI(body);
    }
  }

  public callOnVerifyUserByPhoneAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/verifyUserByPhone',
      body,
    );
  }

  // resetpassword

  public onResetPassword(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnResetPasswordAPI(body)),
      );
    } else {
      return this.callOnResetPasswordAPI(body);
    }
  }

  public callOnResetPasswordAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/resetpassword',
      body,
    );
  }

  // v8/common/forgotpassword
  public onForgotpassword(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnForgotpasswordAPI(body)),
      );
    } else {
      return this.callOnForgotpasswordAPI(body);
    }
  }

  public callOnForgotpasswordAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/forgotpassword',
      body,
    );
  }

  public sendOTPViaWhatsApp(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callSendOTPViaWhatsAppAPI(body)),
      );
    } else {
      return this.callSendOTPViaWhatsAppAPI(body);
    }
  }

  public callSendOTPViaWhatsAppAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/send-message',
      body,
    );
  }

  public sendOTPOverCall(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callSendOTPOverCallAPI(body)),
      );
    } else {
      return this.callSendOTPOverCallAPI(body);
    }
  }

  public callSendOTPOverCallAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/getOTPOverCall',
      body,
    );
  }

  // get sectorList
  public onLoadSectorList(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnLoadSectorListAPI(body)),
      );
    } else {
      return this.callOnLoadSectorListAPI(body);
    }
  }

  public callOnLoadSectorListAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/sectorList',
      body,
    );
  }

  // v12/pdas/savePdasBussinessName
  public onSavePdasBussinessName(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callOnSavePdasBussinessNameAPI(body)),
      );
    } else {
      return this.callOnSavePdasBussinessNameAPI(body);
    }
  }

  public callOnSavePdasBussinessNameAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/savePdasBussinessName',
      body,
    );
  }

  // web/pdasDashboard
  public getDashboardData(data?) {
    if (!this.api_version) {
      this.getApiVersion().then(() => {
        return this.callgetDashboardDataAPI();
      });
    } else {
      return this.callgetDashboardDataAPI();
    }
  }

  callgetDashboardDataAPI() {
    this._dataService
      .postDataWithHeader(
        this._configuration.API_ENDPOINT +
        'v' +
        this.api_version +
        '/pdas/web/pdasDashboard',
        {},
      )
      .subscribe((res: any) => {
        if (res.response == 1) {
          this.walletAmount.next(res?.data?.balance || 0);
          this.userProfileData.next(res?.data || null);
        } else {
          this.walletAmount.next(0);
        }
      });
  }

  // for Autologin
  getCustomerDetails(body) {
    return new Promise((resolve, reject) => {
      this._dataService
        .postDataWithoutHeader(
          ApiEndPointUrl +
          'v' +
          this.api_version +
          '/pdas/web/validatePdasUserById',
          body,
        )
        .subscribe((res: any) => {
          if (res.response == 1) {
            localStorage.setItem('PWAToken', res.data.token);
            localStorage.setItem('phoneCode', res.data.user.phoneCode);
            localStorage.setItem(
              'country',
              res.data.user.phoneCode == '+233' ? 'Ghana' : 'Nigeria',
            );
            localStorage.setItem('authUser', JSON.stringify(res.data.user));
            localStorage.setItem('firstName', res?.data?.user?.firstName || '');
            localStorage.setItem('isWalletWelcomeShow', '0');
            this.getDashboardData();
            resolve(res.data);
          } else {
            resolve(false);
            this._matSnackBar.open(res.message, 'OKAY', { duration: 3000 });
          }
        }, reject);
    });
  }

  // wallet apis
  //v12/pdas/pdasTransactionHistory
  public getPDASTransactionHistoty(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetPDASTransactionHistotyAPI(body)),
      );
    } else {
      return this.callGetPDASTransactionHistotyAPI(body);
    }
  }

  public callGetPDASTransactionHistotyAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/pdasTransactionHistory',
      body,
    );
  }

  // add fund to wallet
  public addFundToWallet(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callAddFundToWalletAPI(body)),
      );
    } else {
      return this.callAddFundToWalletAPI(body);
    }
  }

  public callAddFundToWalletAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/generate-addToWallet-link',
      body,
    );
  }

  public onCheckaddToWalletStatus(status, token, remark): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() =>
          this.callOnCheckaddToWalletStatusAPI(status, token, remark),
        ),
      );
    } else {
      return this.callOnCheckaddToWalletStatusAPI(status, token, remark);
    }
  }

  public callOnCheckaddToWalletStatusAPI(status, token, remark) {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT +
      `v${this.api_version}/pdas/checkaddToWalletStatus?status=${status}&token=${token}&remark=${remark}`,
    );
  }

  /* 
        TO GET STANDARD ORDER PAYLOAD.
    */
  public loadFailbackOrderData(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callLoadFailbackOrderDataAPI(body)),
      );
    } else {
      return this.callLoadFailbackOrderDataAPI(body);
    }
  }

  public callLoadFailbackOrderDataAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/getOrderPayload',
      body,
    );
  }

  /* 
        pdas-discount-list 
    */
  public getPdasDiscountList(): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetPdasDiscountListAPI()),
      );
    } else {
      return this.callGetPdasDiscountListAPI();
    }
  }

  public callGetPdasDiscountListAPI() {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-pdas-discount-list',
    );
  }

  /* 
        GET AFFILIATE DETAILS
    */

  public getAffiliateUserData(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetAffiliateUserDataAPI(body)),
      );
    } else {
      return this.callGetAffiliateUserDataAPI(body);
    }
  }

  public callGetAffiliateUserDataAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/get-affiliate-links',
      body,
    );
  }

  /* 
        Increase Whatsapp Count.
    */

  public increaseWhatsappCount(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callIncreaseWhatsappCountAPI(body)),
      );
    } else {
      return this.callIncreaseWhatsappCountAPI(body);
    }
  }

  public callIncreaseWhatsappCountAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/increase-whatsapp-count',
      body,
    );
  }

  public pdasSendResetPasswordMessage(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callPdasSendResetPasswordMessageAPI(body)),
      );
    } else {
      return this.callPdasSendResetPasswordMessageAPI(body);
    }
  }

  public callPdasSendResetPasswordMessageAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/pdas-send-reset-password-message',
      body,
    );
  }

  public pdasSendResetPasswordCall(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callPdasSendResetPasswordCallAPI(body)),
      );
    } else {
      return this.callPdasSendResetPasswordCallAPI(body);
    }
  }

  public callPdasSendResetPasswordCallAPI(body) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/common/web/pdas-forgot-password-otp-call',
      body,
    );
  }

  // getIPAddress(): Observable<any> {
  //     return this._dataService.getDataWithoutHeader('https://cors-anywhere.herokuapp.com/https://api.ipify.org?format=json');
  // }

  public getPendingFeedbacks() {
    return this._dataService.getDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-nonrated-complete-orders',
    );
  }

  public storeFeedBackRating(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/customer/web/store-orders-rating',
      payload,
    );
  }

  public exportBulkOrder(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-bulk-order-export',
      payload,
    );
  }

  public exportStandardOrder(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-standard-order-export',
      payload,
    );
  }

  public getWebDestinations(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/get-destinations',
      payload,
    );
  }

  public confirmInterRegionalOrder(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callConfirmInterRegionalOrderAPI(body)),
      );
    } else {
      return this.callConfirmInterRegionalOrderAPI(body);
    }
  }

  public callConfirmInterRegionalOrderAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/place-inter-regional-order',
      body,
    );
  }

  // Add payment confirmation method for inter-regional orders
  public interRegionalOrderPaymentConfirm(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callInterRegionalOrderPaymentConfirmAPI(body)),
      );
    } else {
      return this.callInterRegionalOrderPaymentConfirmAPI(body);
    }
  }

  public callInterRegionalOrderPaymentConfirmAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/place-inter-regional-order',
      body,
    );
  }

  public updateInterRegionalOrderStatus(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callUpdateInterRegionalOrderStatusAPI(body)),
      );
    } else {
      return this.callUpdateInterRegionalOrderStatusAPI(body);
    }
  }

  public callUpdateInterRegionalOrderStatusAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/confirm-inter-regional-order-payment/',
      body,
    );
  }

  public downloadWaybill(data): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callDownloadWaybillAPI(data)),
      );
    } else {
      return this.callDownloadWaybillAPI(data);
    }
  }

  public callDownloadWaybillAPI(data) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/download-waybill`,
      data,
    );
  }

  public getInterRegionalOrderDetail(orderId: string): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetInterRegionalOrderDetailAPI(orderId)),
      );
    } else {
      return this.callGetInterRegionalOrderDetailAPI(orderId);
    }
  }

  public callGetInterRegionalOrderDetailAPI(orderId: string) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-inter-regional-order-detail`,
      { orderId },
    );
  }

  public getQrOrderDetails(orderId: string, dropId: string): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetQrOrderDetailsAPI(orderId, dropId)),
      );
    } else {
      return this.callGetQrOrderDetailsAPI(orderId, dropId);
    }
  }

  private callGetQrOrderDetailsAPI(orderId: string, dropId: string) {
    return this._dataService.getDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/get-qr-order-details/${orderId}/${dropId}`,
    );
  }

  public getDsOrderDetails2(data: any): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetDsOrderDetailsAPI2(data)),
      );
    } else {
      return this.callGetDsOrderDetailsAPI2(data);
    }
  }

  public callGetDsOrderDetailsAPI2(data: any) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/get-inter-regional-order-tracking`,
      data,
    );
  }

  public getDsOrderDetails(data: any): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetDsOrderDetailsAPI(data)),
      );
    } else {
      return this.callGetDsOrderDetailsAPI(data);
    }
  }

  public callGetDsOrderDetailsAPI(data: any) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/get-ds-order-details`,
      data,
    );
  }

  // reverse geo code
  public reverseGeoCode(body): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callReverseGeoCodeAPI(body)),
      );
    } else {
      return this.callReverseGeoCodeAPI(body);
    }
  }

  public callReverseGeoCodeAPI(body) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/reverse-geo-code',
      body,
    );
  }

  public updateDsOrderStatus(body: any): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callUpdateDsOrderStatusAPI(body)),
      );
    } else {
      return this.callUpdateDsOrderStatusAPI(body);
    }
  }

  public callUpdateDsOrderStatusAPI(body: any) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/update-order-by-ds`,
      body,
    );
  }

  public assignRider(body: any): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callAssignRider(body)),
      );
    } else {
      return this.callAssignRider(body);
    }
  }

  public callAssignRider(body: any) {
    const apiRes = this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/web/store-driver-info-by-ds`,
      body,
    );

    console.log('body in the pi call', apiRes);
    return apiRes;
  }

  public getNotified(payload) {
    return this._dataService.postDataWithHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/pdas/web/store-unavailable-city',
      payload,
    );
  }

  public getDsOrderDetailsDropTracking(data: any): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callGetDsOrderDetailsDropTrackingAPI2(data)),
      );
    } else {
      return this.callGetDsOrderDetailsDropTrackingAPI2(data);
    }
  }

  public callGetDsOrderDetailsDropTrackingAPI2(data: any) {
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      `/pdas/get-inter-regional-drop-tracking`,
      data,
    );
  }

  /* 
        Public Tracking - shopify endpoint (NO LOGIN required)
        Endpoint: {host}/shopify/track-order
  */
  public shopifyTrackOrder(data: { dropTrackId: string }): Observable<any> {
    if (!this.api_version) {
      return from(this.getApiVersion()).pipe(
        switchMap(() => this.callShopifyTrackOrderAPI(data)),
      );
    }
    return this.callShopifyTrackOrderAPI(data);
  }

  private callShopifyTrackOrderAPI(data: {
    dropTrackId: string;
  }): Observable<any> {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';

    // This endpoint is not under `${API_ENDPOINT}/v{version}`.
    return this._dataService.postDataWithoutHeader(
      this._configuration.API_ENDPOINT +
      'v' +
      this.api_version +
      '/shopify/track-order',
      data,
    );
  }
}
